import { render, staticRenderFns } from "./RoomEditor.vue?vue&type=template&id=6e9d8c2a&"
import script from "./RoomEditor.vue?vue&type=script&lang=js&"
export * from "./RoomEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports